export * from "./phone";
export * from "./location";
export * from "./mail";
export * from "./checklist";
export * from "./packagetime";
export * from "./protect";
export * from "./warning";
export * from "./pack";
export * from "./decant";
export * from "./declarat";
export * from "./expertLocation";
export * from "./protect";
export * from "./train";
export * from "./transport";
export * from "./warehouse";
export * from "./arrow-circle-down";
export * from "./arrow-cicle-right";
export * from "./20-years";
export * from "./cost";
export * from "./check-circle";
export * from "./arrow-right-circle-solid";
export * from "./arrow-circle-left";
export * from "./chevreon-up";
export * from "./chevron-double-down";
export * from "./bars-3";
export * from "./x-mark";
export * from "./arrow-left";
export * from "./funnel";
export * from "./funnel-solid";
export * from "./check"; 
export * from "./whatsapp"; 
